import React, { useEffect, useState } from 'react';
import CText from '../../common/CText';
import { View } from 'react-native';
import CInput from '../../common/CInput';
import CustomButton from '../../common/CustomButton';
import CHeader from '../../common/CHeader';
import CDropdown from '../../common/CDropdown';
import { panValidationV2 } from '../../api/digiLockerApi';
import { createLoan, getCustomerInfo, getStateList, getCityList } from '../../api/usedCarLoan';
import Loader from '../../common/Loader';
import ModalAlert from '../../common/ModalAlert';
import pickerConstant from '../../constant/pickerConstant';
import moment from 'moment';
import useStyles from './CustomerInformation_Styles';
import CPanDetails from '../../common/CPanDetails';

export default function CustInformation(props) {
  const styles = useStyles();
  const onlyAlphabetPattern = '[A-Za-z]';
  const emailPattern = '^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$';
  const [panNumber, setPanNumber] = useState('');
  const [data, setData] = useState({
    emailId: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dob: '',
  });
  const [editableData, setEditableData] = useState({
    emailId: false,
    address1: false,
    address2: false,
    city: false,
    state: false,
    zipCode: false,
    gender: false,
    firstName: false,
    middleName: false,
    lastName: false,
    dob: false,
  });
  const [loading, setLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [isPanAutheniticated, setIsPanAuthenticated] = useState(false);
  const [panError, setPanError] = useState(false);
  const [enableProceed, setEnableProceed] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: '',
    status: '',
    message: '',
    navigateScreen: '',
    navigate: '',
    actionButton: '',
  });

  const onHandleInput = (key, value) => {
    const dataObj = { ...data };
    dataObj[key] = value;
    setData(dataObj);
  };

  const onCloseModal = () => {
    if (alertModal.navigateScreen == 'CarLoanIndex') {
      setAlertModalVisible(false);
      props.setActiveScreen('CarLoanIndex');
    } else {
      setAlertModalVisible(false);
    }
  };

  useEffect(() => {
    getInfo();
    sateList();
  }, []);

  const applyLoan = () => {
    setLoading(true);
    const param = {
      customerInfo: {
        location: data.city,
        emailId: data.emailId,
        city: data.city,
        state: data.state,
        addressLine1: data.address1,
        pincode: data.zipCode,
        addressLine2: data.address2,
        gender: data.gender,
        dateOfBirth: data.dob,
        maritalStatus: data.maritalStatus,
        firstName: data.firstName,
        mobileNumber: props.basicData.mobileNo,
        middleName: data.middleName,
        lastName: data.lastName,
      },
      documentInfo: {
        docType: 'PAN',
        docNo: panNumber.toUpperCase(),
      },
    };
    createLoan(param)
      .then((res) => {
        setLoading(false);

        if (res.statusCode == 1072) {
          props.setStatusData(res);
          props.setActiveScreen('EmpInformation');
          props.fromScreen('CustomerInformation');
        } else if (res.statusCode == -1072 || res.statusCode == 500) {
          setAlertModalVisible(true);
          setAlertModal({
            title: 'Error',
            status: 'error',
            message: res.message,
            navigateScreen: '',
            navigate: 'Dashboard',
            actionButton: 'OK',
          });
        } else if (res.statusCode == -1042) {
          setAlertModalVisible(true);
          setAlertModal({
            title: 'Error',
            status: 'error',
            message: res.message,
            navigateScreen: '',
            actionButton: 'OK',
          });
          // setIsPanAuthenticated(false);
          // setPanNumber('');
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const getInfo = () => {
    setLoading(true);
    getCustomerInfo({ mobileNo: props?.basicData?.mobileNo, requestId: props.otpData.requestId })
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 1074) {
          if (res.data) {
            setData({
              emailId: res.data?.emailId,
              address1: res.data?.address1,
              address2: res.data?.address2,
              city: res.data?.city,
              state: res.data?.state,
              zipCode: res.data?.zipCode,
              gender: res.data?.gender == 'F' ? 'Female' : res.data?.gender == 'M' ? 'Male' : 'Transgender',
              dob: res.data?.dob != '' ? moment(res.data?.dob).format('DD/MM/YYYY') : '',
            });
            setEditableData({
              emailId: res.data?.emailId != ('' || undefined) ? false : true,
              address1: true,
              address2: true,
              city: true,
              state: true,
              zipCode: true,
              gender: res.data?.gender != ('' || undefined) ? false : true,
              dob: res.data?.dob != ('' || undefined) ? true : false,
            });
          }
        } else if (res.statusCode == -1075 || res.statusCode == 500) {
          setAlertModalVisible(true);
          setAlertModal({
            title: 'Error',
            status: 'error',
            message: res.message,
            navigateScreen: 'CarLoanIndex',
            navigate: 'Dashboard',
            actionButton: 'OK',
          });
        } else {
          setEditableData({
            emailId: true,
            address1: true,
            address2: true,
            city: true,
            state: true,
            zipCode: true,
            gender: true,
            dob: false,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setAlertModalVisible(true);
        setAlertModal({
          title: 'Error',
          status: 'error',
          message: err.message,
          navigateScreen: 'CarLoanIndex',
          navigate: 'Dashboard',
          actionButton: 'OK',
        });
      });
  };

  const validatePan = (req) => {
    setPanNumber(req?.panNumber.toUpperCase())
    let param = {
      panNumber: req?.panNumber.toUpperCase(),
      fullName: req?.fullName,
      dob: req?.dob,
      mobileNo: props.basicData.mobileNo,
    };
    setLoading(true);
    panValidationV2(param)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 200) {
            setPanError(false)
          setIsPanAuthenticated(true);
          let obj = {
            firstName: res?.data?.firstName,
            middleName: res?.data?.middleName || '',
            lastName: res?.data?.lastName,
            dob: req?.dob,
          };
          setData({ ...data, ...obj });
        } else if ([-1042, 500,1016].includes(res.statusCode)) {
          setIsPanAuthenticated(false);
          setPanError(true)
          setAlertModalVisible(true);
          setAlertModal({
            title: 'Error',
            status: 'error',
            message: res.message,
            navigateScreen: '',
            actionButton: 'OK',
          });
        }
      })
      .catch((err) => {});
  };
  //Function will call api to get list of states
  const sateList = () => {
    getStateList()
      .then((res) => {
        var arr = [];
        res.data.states.map((item) => {
          arr.push({ label: item, value: item });
        });
        setStateList(arr);
      })
      .catch();
  };
  const getCity = () => {
    getCityList({ state: data.state })
      .then((res) => {
        console.log(res);
        var arr = [];
        res.data.locations.map((item) => {
          arr.push({ label: item, value: item });
        });
        setCityList(arr);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (data.state) {
      getCity();
    }
  }, [data.state]);

  useEffect(() => {
    console.log('setData', data, editableData);
    if (
      isPanAutheniticated &&
      data.firstName &&
      data.firstName != (undefined || '') &&
      data.lastName &&
      data.lastName != (undefined || '') &&
      data.maritalStatus &&
      data.maritalStatus != (undefined || '') &&
      data.gender &&
      data.gender != (undefined || '') &&
      data.address2 &&
      data.address2 != (undefined || '') &&
      data.dob &&
      data.dob != '' &&
      data.zipCode &&
      data.zipCode != (undefined || '') &&
      data.address1 &&
      data.address1 != (undefined || '') &&
      data.state &&
      data.state != (undefined || '') &&
      data.emailId &&
      data.emailId != (undefined || '') &&
      data.city &&
      data.city != (undefined || '')
    ) {
      setEnableProceed(true);
    } else {
      setEnableProceed(false);
    }
    // }
  }, [data]);

  return (
    <>
      <View>
        <CHeader
          title='Step 2 of 5'
          onPress={props.setActiveScreen}
          navigation='BasicDetails'
        />
      </View>
      <View style={styles.contentWrapper}>
        <View>
          <CText.basicInformation>Customer Information</CText.basicInformation>
        </View>

        <View style={styles.panWrapper}>
          <CPanDetails
            type={'ucl'}
            onSubmit={validatePan}
            isPanAutheniticated={isPanAutheniticated}
            isError={panError}
          />
        </View>

        <View style={[styles.custInfoWrapper, { zIndex: 3 }]}>
          <View style={styles.infoWrapper}>
            <CInput
              inputType='alpha'
              pattern={onlyAlphabetPattern}
              disable={false}
              maxLength={20}
              label='First name'
              style={{ width: 230 }}
              value={isPanAutheniticated ? data.firstName : ''}
              onChangeText={(value) => onHandleInput('firstName', value)}
              mandatoryField={true}
            />
            <CInput
              inputType='alpha'
              maxLength={20}
              label='Middle name'
              style={{ width: 230 }}
              pattern={onlyAlphabetPattern}
              value={isPanAutheniticated ? data.middleName : ''}
              disable={false}
              onChangeText={(value) => onHandleInput('middleName', value)}
            />
            <CInput
              inputType='alpha'
              maxLength={20}
              label='Last name'
              style={{ width: 230 }}
              pattern={onlyAlphabetPattern}
              disable={false}
              value={isPanAutheniticated ? data.lastName : ''}
              mandatoryField={true}
              onChangeText={(value) => onHandleInput('lastName', value)}
            />
          </View>
          <View style={[styles.infoWrapper, { zIndex: 9 }]}>
            <View style={{ zIndex: 9 }}>
              <CInput
                label='Email'
                style={{ width: 230 }}
                maxLength={30}
                pattern={emailPattern}
                value={isPanAutheniticated ? data.emailId : ''}
                disable={editableData?.emailId == false ? false : true}
                mandatoryField={true}
                onChangeText={(value) => onHandleInput('emailId', value)}
              />
            </View>
            <View style={{ zIndex: 8 }}>
              <CDropdown
                label='Maritial status'
                mandatoryField={true}
                value={isPanAutheniticated ? data.maritalStatus : ''}
                disable={!isPanAutheniticated}
                onSelect={(value) => onHandleInput('maritalStatus', value)}
                items={pickerConstant.maritalStatus}
                style={{ width: 230 }}
              />
            </View>
            <View style={{ zIndex: 7 }}>
              <CDropdown
                label='Gender'
                value={isPanAutheniticated ? data.gender : ''}
                mandatoryField={true}
                disable={!editableData?.gender}
                onSelect={(value) => onHandleInput('gender', value)}
                items={pickerConstant.gender}
                style={{ width: 230 }}
              />
            </View>
          </View>
          <View style={[styles.infoWrapper, { zIndex: 6 }]}>
            <View style={{ zIndex: 6 }}>
              <CInput
                label='Address Line 1'
                maxLength={30}
                style={{ width: 230 }}
                value={isPanAutheniticated ? data.address1 : ''}
                mandatoryField={true}
                disable={isPanAutheniticated}
                onChangeText={(value) => onHandleInput('address1', value)}
              />
            </View>
            <View style={{ zIndex: 5 }}>
              <CInput
                label='Address Line 2'
                mandatoryField={true}
                maxLength={30}
                style={{ width: 230 }}
                value={isPanAutheniticated ? data.address2 : ''}
                disable={isPanAutheniticated}
                onChangeText={(value) => onHandleInput('address2', value)}
              />
            </View>
            <View style={{ zIndex: 5 }}>
              <CDropdown
                label='State'
                value={isPanAutheniticated ? data.state : ''}
                mandatoryField={true}
                disable={!isPanAutheniticated}
                onSelect={(value) => onHandleInput('state', value)}
                items={stateList}
                style={{ width: 230 }}
              />
            </View>
          </View>
          <View style={[styles.infoWrapper, { zIndex: 5 }]}>
            <View style={{ zIndex: 5 }}>
              <CDropdown
                label='City'
                style={{ width: 230 }}
                value={isPanAutheniticated ? data.city : ''}
                mandatoryField={true}
                items={cityList}
                disable={!isPanAutheniticated}
                onSelect={(value) => onHandleInput('city', value)}
              />
            </View>
            <View style={{ zIndex: 4 }}>
              <CInput
                label='Pin Code'
                mandatoryField={true}
                style={{ width: 230 }}
                value={isPanAutheniticated ? data.zipCode : ''}
                onChangeText={(value) => onHandleInput('zipCode', value)}
                maxLength={6}
                disable={isPanAutheniticated}
                inputType='numeric'
              />
            </View>
          </View>
        </View>

        <View style={[styles.footer, { zIndex: 2 }]}>
          <CustomButton
            text='Proceed'
            onPress={enableProceed ? applyLoan : ()=>{}}
            disable={!enableProceed}
          />
        </View>
        {alertModalVisible && (
          <View style={styles.overlayViewStyle}>
            <ModalAlert
              title={alertModal.title}
              status={alertModal.status}
              message={alertModal.message}
              navigateScreen={alertModal.navigateScreen}
              actionButton={'OK'}
              onCloseModal={onCloseModal}
            />
          </View>
        )}

        {loading && <Loader />}
      </View>
    </>
  );
}
